var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Input__container"},[_vm._t("default"),_c('div',{staticClass:"Input__loading"},[(_vm.loading)?_c('LoadingIcon',{attrs:{"small":true}}):_vm._e()],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }